import { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import CustomSelect from "../../component/CustomSelect";
import Icons from "../../myIcon/Icons";

const statusOptions = [{ _id: "1", name: "Disable" }, { _id: "0", name: "Enable" }];

export default function AddNewsCategory({ show, onHide }) {
  const [data, setData] = useState({ name: "", status: "0" });
  const handleChange = (event) => setData((previous) => ({ ...previous, [event.target.name]: event.target.value }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!data.name.trim()) return toast.error("Category name is required.");
    try {
      const response = await ApiRequest("POST", ApiEndpoints.newsCategory.categoryCreate, data);
      toast.success(response.message);
      setData({ name: "", status: "0" });
      onHide();
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to create media category.");
    }
  };

  return (
    <Modal className="add-modal-area" show={show} onHide={onHide} size="sm" centered>
      <Modal.Body>
        <button className="modal-close-button" onClick={onHide}><Icons name="cross" /></button>
        <form onSubmit={handleSubmit}>
          <div className="add-page-inputs">
            <div className="col-lg-12"><div className="add-page-sections">Create Media Category</div></div>
            <div className="label-wrap-add"><label>Category<small>*</small></label></div>
            <input name="name" type="text" value={data.name} onChange={handleChange} className="form-control" placeholder="Enter Here" />
          </div>
          <div className="add-page-inputs">
            <div className="label-wrap-add"><label>Status<small>*</small></label></div>
            <CustomSelect name="status" options={statusOptions} defaultValue={data.status} onChange={handleChange} />
          </div>
          <button type="submit" className="default-btn">add<span></span></button>
        </form>
      </Modal.Body>
    </Modal>
  );
}
